import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { useKeycloak } from '@react-keycloak/web';
import { Protected } from './Protected';
import RoutesWithNavbar from './routes-with-navbar';
import Dashboard from '../../components/pages/dashboard';
import Profile from '../../components/pages/profile/profile';
import BankAccounts from '../../components/pages/bank-accounts/bank-accounts';
import React from 'react';
import Footer from '../../components/layout/footer/footer';

const KeycloakAppRoutes = () => {
   const { initialized } = useKeycloak();

   const router = createBrowserRouter([
      {
         path: '/',
         element: <Protected component={
            <div className="min-vh-100 d-flex flex-column">
               <RoutesWithNavbar/><Dashboard /><Footer />
            </div>
         } />,
      },
      {
         path: '/login',
         element: <Protected component={
            <div className="min-vh-100 d-flex flex-column">
               <RoutesWithNavbar/><Dashboard /><Footer />
            </div>
         } />,
      },
      {
         path: '/profile',
         element: <Protected component={
            <div className="min-vh-100 d-flex flex-column">
               <RoutesWithNavbar/><Profile /><Footer />
            </div>
         } />,
      },
      {
         path: '/bank-accounts',
         element: <Protected component={
            <div className="min-vh-100 d-flex flex-column">
               <RoutesWithNavbar/><BankAccounts /><Footer />
            </div>
         } />,
      },
   ]);

   if (!initialized) {
      return <div>Loading...</div>;
   }

   return <RouterProvider router={router} />;
};

export default KeycloakAppRoutes;
